module.exports = __webpack_public_path__ + "img/msp0.2b74f27b.gif";